import React, { memo, useState } from 'react'
import styled, { css, keyframes } from 'styled-components'
import Next from '../../../../public/svg/next'
import Back from '../../../../public/svg/back'
import Location from '../../../../public/svg/shop'
import Toys from '../../../../public/svg/toys'
import Pacifier from '../../../../public/svg/pacifier'
import Bike from '../../../../public/svg/bycicle'
import Book from '../../../../public/svg/book'
import School from '../../../../public/svg/school'
import CombAndBrush from '../../../../public/svg/comb'
import KidsClothes from '../../../../public/svg/baby'
import IconUser from '../../../../public/svg/user_outlined'
import IconFavorites from '../../../../public/svg/heart-bold'
import IconBasket from '../../../../public/svg/cart'

import {
  BaseMenuItem,
  MenuColumns,
  MenuSubcategory,
  Labels,
} from '../../../MenuLayout/MenuLayout.props'

import {
  Button,
  IconClose,
  IconPhone,
  OverflowHidden,
  Typography,
} from '../../../Common'
import { useRouter } from 'next/router'
import Logo from '../../../../public/svg/LogoHippoland'
import {
  useProfile,
  Link,
  useUIFunctions,
  useConfigState,
  useGlobalLabels,
  useLocalLabels,
} from '@sentecacommerce-theme/lib'

export const iconMap: { [key: string]: JSX.Element } = {
  'детски играчки': <Toys />,
  бебешки: <Pacifier />,
  'детски превозни средства': <Bike />,
  книги: <Book />,
  'за ученика': <School />,
  'козметични комплекти и аксесоари': (
    <CombAndBrush style={{ flexBasis: '9%' }} />
  ),
  'детски дрехи': <KidsClothes />,
}

type Props = {
  menuItems: BaseMenuItem[]
  specialItems: BaseMenuItem[]
  open: boolean
  handleOpen: (v: boolean) => void
}

export const MobileMenu = memo((props: Props) => {
  const [activeCategory, setActiveCategory] = useState('')
  const router = useRouter()
  const config = useConfigState()
  const { enter, back } = useGlobalLabels()
  const labels = useLocalLabels<Labels>()
  const { handleOpen, open, specialItems, menuItems } = props

  const handleCategoryChange = (category: BaseMenuItem) => () =>
    setActiveCategory(category.menuName)

  const handleBackClick = () => {
    setActiveCategory('')
  }

  const hideDrawer = () => {
    handleOpen(false)
  }

  const hanleLinkClick = (route: string) => (e: any) => {
    e.preventDefault()
    hideDrawer()

    if (route) {
      router.push(route)
    }
  }

  const goToProfilePage = () => {
    router.push('/profile')
    hideDrawer()
  }

  const { data: user } = useProfile()

  const hasNames = user?.firstName && user?.lastName

  const { enqueueView } = useUIFunctions()

  const IconStyle = {
    height: '1.2rem',
    width: 'auto',
    fill: config.palette.silverTree,
  }

  return (
    <SideDrawer open={open}>
      {open && <OverflowHidden />}
      <Top>
        <Link href="/" passHref>
          <div onClick={() => hideDrawer()}>
            <Logo />
          </div>
        </Link>
        <CloseWrapper>
          <IconClose onClick={hideDrawer} />
        </CloseWrapper>
      </Top>
      <CategoryItemWrapper>
        <CategoryItemListWrapper open={true} activeCategory={activeCategory}>
          <CategoryItemList open={!activeCategory}>
            <SectionName>{labels?.categories}</SectionName>
            {specialItems.map((item) => (
              <CategoryItem key={item.menuName}>
                <CategoryItemLink
                  isSale={item.menuClass === 'sale'}
                  special={item.menuClass === 'special'}
                  href={item.menuUrl as string}
                  name={item?.menuName}
                  onClick={hanleLinkClick(item.menuUrl as string)}
                >
                  {item.menuClass !== 'sale' ? (
                    item.menuName
                  ) : (
                    <ActionImageContainer>
                      <img src={item?.menuImageLink as string} alt="sale" />
                    </ActionImageContainer>
                  )}
                </CategoryItemLink>
              </CategoryItem>
            ))}
            {menuItems?.map((category, idx) => (
              <React.Fragment key={`cat${idx}`}>
                <CategoryItem>
                  <CategoryItemLink
                    as="div"
                    isSale={category.menuClass === 'sale'}
                    onClick={handleCategoryChange(category)}
                  >
                    {iconMap[category.menuName.toLowerCase()]}
                    <span>{category.menuName}</span>
                    <Next style={IconStyle} />
                  </CategoryItemLink>
                  <SubCategoryItemListWrapper
                    open={category.menuName === activeCategory}
                  >
                    <SubCategoryItemList>
                      <li>
                        <BackCategoryLink as="span" onClick={handleBackClick}>
                          <Back style={IconStyle} />
                          {back}
                        </BackCategoryLink>
                      </li>
                      {category.menuClass?.toLowerCase() === 'brand' && (
                        <CategoryItem>
                          <CategoryItemLink
                            href="/brands"
                            onClick={hanleLinkClick('/brands')}
                          >
                            {labels?.brandsAZ}
                          </CategoryItemLink>
                        </CategoryItem>
                      )}
                      {category.columns &&
                        ([] as any[])
                          .concat(
                            (category.columns as MenuColumns).col1,
                            (category.columns as MenuColumns).col2
                          )
                          .map(
                            (subcategory: MenuSubcategory, idx3) =>
                              subcategory && (
                                <React.Fragment key={`subcat${idx3}`}>
                                  <CategoryItem>
                                    <CategoryItemLink
                                      href={subcategory.menuUrl}
                                      onClick={hanleLinkClick(
                                        subcategory.menuUrl
                                      )}
                                    >
                                      {subcategory.menuName}
                                    </CategoryItemLink>
                                  </CategoryItem>
                                </React.Fragment>
                              )
                          )}
                    </SubCategoryItemList>
                  </SubCategoryItemListWrapper>
                </CategoryItem>
              </React.Fragment>
            ))}
            <CategoryItem>
              <ProfileContainer>
                <SectionName>{labels?.myAccount}</SectionName>
                <CategoryItem>
                  <CategoryItemLink
                    href="/favorites"
                    onClick={hanleLinkClick('/favorites')}
                    highlight
                  >
                    <IconFavorites
                      style={{ width: '2.1rem', height: '2.1rem' }}
                    />
                    {labels?.favorites}
                  </CategoryItemLink>
                </CategoryItem>
                <CategoryItem>
                  <CategoryItemLink
                    href="/basket"
                    onClick={hanleLinkClick('/basket')}
                    highlight
                  >
                    <IconBasket style={{ width: '2.1rem', height: '2.1rem' }} />
                    {labels?.basket}
                  </CategoryItemLink>
                </CategoryItem>
                {user && (
                  <>
                    <CategoryItemLink
                      withoutBorderBottom
                      onClick={() => goToProfilePage()}
                    >
                      <IconUser style={{ width: '2rem', height: '2rem' }} />
                      {hasNames
                        ? `${user.firstName} ${user.lastName}`
                        : user.email}
                      <Next style={IconStyle} className="ml-auto" />
                    </CategoryItemLink>
                  </>
                )}
                {!user && (
                  <CategoryItem>
                    <CategoryItemLink
                      withoutBorderBottom
                      as="div"
                      onClick={() => {
                        enqueueView(config.views.auth)
                        hideDrawer()
                      }}
                      className="pb-4"
                    >
                      <Button variant="green" fullWidth>
                        {enter}
                      </Button>
                    </CategoryItemLink>
                  </CategoryItem>
                )}
              </ProfileContainer>
            </CategoryItem>
            <SectionName>{labels?.info}</SectionName>

            <CategoryItem>
              <CategoryItemLink
                highlight
                href="/stores"
                onClick={hanleLinkClick('/stores')}
              >
                <Location style={{ width: '2.4rem', height: '2.4rem' }} />
                {labels?.stores}
              </CategoryItemLink>
            </CategoryItem>

            <CategoryItem>
              <CategoryItemLink highlight href={`tel:${labels?.phoneNumber}`}>
                <IconPhone style={{ width: '2.4rem', height: '2rem' }} />
                {labels?.phoneNumber}
              </CategoryItemLink>
            </CategoryItem>
          </CategoryItemList>
        </CategoryItemListWrapper>
      </CategoryItemWrapper>
    </SideDrawer>
  )
})

const ProfileContainer = styled.div`
  text-align: center;
  border-bottom: 0.1rem solid ${({ theme }) => theme.palette.lightgrey};

  & > span {
    color: ${({ theme }) => theme.palette.silverTree};
    display: block;
    font-size: 1.3rem;
    font-weight: bold;
  }
`

const SectionName = styled.div`
  text-align: center;
  padding: 1.2rem 2.4rem;
  background: rgba(238, 238, 238, 0.4);
  color: ${({ theme }) => theme.palette.silverTree};
  text-transform: uppercase;
  font-size: 1.2rem;
  font-weight: bold;
`

const show = keyframes`
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
`

const showTablet = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
`

const SideDrawer = styled(Typography).attrs({
  as: 'nav',
  variant: 6,
  className: 'd-lg-none',
})<{ open: boolean }>`
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background: ${({ theme }) => theme.palette.secondary};

  z-index: 9999;
  transform: translateX(100%);
  animation: ${show} 0.4s cubic-bezier(0.4, 0, 0.2, 1) 1 forwards;

  @media (min-width: ${({ theme }) => theme.breakpoints.md.min}) {
    animation: ${showTablet} 0.4s cubic-bezier(0.4, 0, 0.2, 1) 1 forwards;
  }
`

const CloseWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  top: 0;
  right: 0;
  padding-right: 2.4rem;

  & > svg {
    width: 1.8rem;
    height: 1.8rem;
    color: ${({ theme }) => theme.palette.silverTree};
  }
`

const Top = styled.div.attrs({
  className: 'p-4',
})`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 0.1rem solid ${({ theme }) => theme.palette.lightgrey};
  position: relative;

  & > div {
    width: 8rem;
  }
`

const CategoryItem = styled.li`
  text-align: match-parent;
`

const CategoryItemWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`

type CategoryItemListWrapperType = {
  open: boolean
  activeCategory: any
}
const CategoryItemListWrapper = styled.div<CategoryItemListWrapperType>`
  position: absolute;
  top: 0;
  left: ${(props) => (props.open ? '0' : '-100%')};
  width: 100%;
  height: ${(props) => (props.activeCategory ? '0' : 'calc(100% - 6.7rem)')};
  overflow: ${(props) => (props.activeCategory ? 'visible' : 'auto')};
`

const CategoryItemList = styled.ul<{ open: boolean }>`
  width: 100%;
  padding-bottom: 2.4rem;

  color: ${({ theme }) => theme.palette.primary};

  transform: translateX(-100%);
  transition: transform 0.3s ease;

  ${(props) =>
    props.open &&
    css`
      transform: translateX(0);
    `};
`

const SubCategoryItemListWrapper = styled.div<{ open: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  display: ${(props) => (props.open ? 'block' : 'none')};
  transform: translateX(100%);
  height: 100vh;
  overflow: auto;
`

const SubCategoryItemList = styled.ul.attrs({
  className: 'pb-2 mt-2 mb-4',
})`
  color: ${({ theme }) => theme.palette.primary};
  max-height: calc(100vh - 6.7rem);
  overflow: auto;
`

type CategoryItemLink = {
  isSale?: boolean
  special?: boolean
  bold?: boolean
  locations?: boolean
  withoutBorderBottom?: boolean
  highlight?: boolean
  name?: string
}
const CategoryItemLink = styled.a<CategoryItemLink>`
  color: ${({ theme }) => theme.palette.silverTree};
  font-weight: ${(props) => (props.bold ? '600' : '400')};
  display: flex;
  padding: 1.2rem 2.4rem;
  justify-content: flex-start;
  text-overflow: ellipsis;
  align-items: center;
  white-space: break-spaces;
  /* background: ${(props) =>
    props.highlight ? 'rgba(233, 245, 232, 0.5)' : 'transparent'}; */
  border-bottom: 0.1rem solid
    ${(props) =>
      props.withoutBorderBottom
        ? 'transparent'
        : props.theme.palette.lightgrey};

  ${(props) =>
    props.isSale &&
    css`
      color: ${({ theme }) => theme.palette.danger};
    `};
  ${(props) =>
    props.special &&
    css`
      color: ${({ theme }) => theme.palette.silverTree};
    `};

  ${(props) =>
    props.locations &&
    css`
      margin-top: 4rem !important;
      border-top: 0.1rem solid ${({ theme }) => theme.palette.lightgrey};
    `}

  ${(props) =>
    props.name === 'Топ Оферти' &&
    css`
      color: ${({ theme }) => theme.palette.danger};
    `}
  ${(props) =>
    props.name === 'Акция' &&
    css`
      padding: 1rem 2.4rem;
    `}

  & span {
    margin-right: auto;
    flex-basis: 80%;
    color: ${({ theme }) => theme.palette.silverTree};
  }
  & svg:first-of-type {
    fill: ${({ theme }) => theme.palette.silverTree};
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
`

const BackCategoryLink = styled.a`
  color: ${({ theme }) => theme.palette.silverTree};
  display: flex;
  align-items: center;
  padding: 1.2rem 2.4rem;
  text-overflow: ellipsis;
  border-bottom: 0.1rem solid ${({ theme }) => theme.palette.lightgrey};

  > svg {
    margin-right: 1.2rem;
  }
`
const ActionImageContainer = styled.div`
  position: relative;
  top: 0.3rem;
  & img {
    width: 6rem;
    height: 2rem;
  }
`
